import React, { useState, useEffect, useContext } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { productService } from '../../service/productservice';
import { Cloudinary } from "@cloudinary/url-gen";


import PineGreenBathingSponge from "../../public/category-img/sponges/PineGreenBathingSponge_prev_ui.png";
import YellowBathingSponge from "../../public/category-img/sponges/YellowBathingSponge_prev_ui.png";
import BlueBathingSponge from "../../public/category-img/sponges/Blue Bathing Sponge.jpg";
import BrownBathingSponge from "../../public/category-img/sponges/Brown Bathing Sponge.jpg";
import RedBathingSponge from "../../public/category-img/sponges/30gm-loofah-sponge-500x500.jpg";
import LightRedBathingSponge from "../../public/category-img/sponges/Red Bathing Sponge.jpg";
import BurgundyBathingSponge from "../../public/category-img/sponges/BurgundyBathingSponge.jpg";
import LightGreenBathingSponge from "../../public/category-img/sponges/bathsponge-18__71443-removebg-preview__68423.1661191469.350.350.png";
import OrangeBathingSponge from "../../public/category-img/sponges/OrangeBathingSponge.jpg";

// Initialize Cloudinary URL generator outside the component
const cld = new Cloudinary({ cloud: { cloudName: 'dwpoik1jm' } });



export const spongeproducts = [
  { id: "AS001", name: "Pine Green Bathing Sponge", brand: "Unbranded", price: "$3.95", img: PineGreenBathingSponge, description: "African Sponge in pine green color is a natural, exfoliating product used for bathing. Made from the fibrous interior of the luffa plant, this sponge offers excellent cleansing properties with its coarse texture that helps remove dead skin cells and promote healthier skin." },
  { id: "AS002", name: "Matte Green Bathing Sponge", brand: "Unbranded", price: "$3.95", img: "", description: "African Sponge in matte green color is a natural, exfoliating product used for bathing. Made from the fibrous interior of the luffa plant, this sponge offers excellent cleansing properties with its coarse texture that helps remove dead skin cells and promote healthier skin." },
  { id: "AS003", name: "Yellow Bathing Sponge", brand: "Unbranded", price: "$3.95", img: YellowBathingSponge, description: "African Sponge in yellow color is a natural, exfoliating product used for bathing. Made from the fibrous interior of the luffa plant, this sponge offers excellent cleansing properties with its coarse texture that helps remove dead skin cells and promote healthier skin." },
  { id: "AS004", name: "Blue Bathing Sponge", brand: "Unbranded", price: "$3.95", img: BlueBathingSponge, description: "African Sponge in blue color is a natural, exfoliating product used for bathing. Made from the fibrous interior of the luffa plant, this sponge offers excellent cleansing properties with its coarse texture that helps remove dead skin cells and promote healthier skin." },
  { id: "AS005", name: "Brown Bathing Sponge", brand: "Unbranded", price: "$3.95", img: BrownBathingSponge, description: "African Sponge in brown color is a natural, exfoliating product used for bathing. Made from the fibrous interior of the luffa plant, this sponge offers excellent cleansing properties with its coarse texture that helps remove dead skin cells and promote healthier skin." },
  { id: "AS006", name: "Red Bathing Sponge", brand: "Unbranded", price: "$3.95", img: RedBathingSponge, description: "African Sponge in red color is a natural, exfoliating product used for bathing. Made from the fibrous interior of the luffa plant, this sponge offers excellent cleansing properties with its coarse texture that helps remove dead skin cells and promote healthier skin." },
  { id: "AS007", name: "Light Red Bathing Sponge", brand: "Unbranded", price: "$3.95", img: LightRedBathingSponge, description: "African Sponge in light red color is a natural, exfoliating product used for bathing. Made from the fibrous interior of the luffa plant, this sponge offers excellent cleansing properties with its coarse texture that helps remove dead skin cells and promote healthier skin." },
  { id: "AS008", name: "Burgundy Bathing Sponge", brand: "Unbranded", price: "$3.95", img: BurgundyBathingSponge, description: "African Sponge in burgundy color is a natural, exfoliating product used for bathing. Made from the fibrous interior of the luffa plant, this sponge offers excellent cleansing properties with its coarse texture that helps remove dead skin cells and promote healthier skin." },
  { id: "AS009", name: "Light Green Bathing Sponge", brand: "Unbranded", price: "$3.95", img: LightGreenBathingSponge, description: "African Sponge in light green color is a natural, exfoliating product used for bathing. Made from the fibrous interior of the luffa plant, this sponge offers excellent cleansing properties with its coarse texture that helps remove dead skin cells and promote healthier skin." },
  { id: "AS010", name: "Orange Bathing Sponge", brand: "Unbranded", price: "$3.95", img: OrangeBathingSponge, description: "African Sponge in orange color is a natural, exfoliating product used for bathing. Made from the fibrous interior of the luffa plant, this sponge offers excellent cleansing properties with its coarse texture that helps remove dead skin cells and promote healthier skin." }
];

const ProductCard = ({ product, updateCartCount, forceUpdateKey }) => {
  const [inCart, setInCart] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const foundItem = storedCartItems.find((item) => item.id === product.id);
    if (foundItem) {
      setInCart(true);
      setQuantity(foundItem.quantity);
    } else {
      setInCart(false);
      setQuantity(0);
    }
  }, [product.id, forceUpdateKey]);

  const handleAddToCart = () => {
    if (!inCart) {
      setInCart(true);
      setQuantity(1);
      saveToLocalStorage(product, 1);
      updateCartCount();
    }
  };

  const handleProductClick = () => {
    navigate(`/product/${product.name}`);
  };

  const saveToLocalStorage = (product, quantity) => {
    const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const updatedCart = [...cartItems, { ...product, quantity }];
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-3 w-full flex flex-col justify-between">
      <div onClick={handleProductClick} className="relative cursor-pointer flex justify-center items-center">
        <img
          src={product.img}
          alt={product.name}
          className={`h-60 w-full object-cover rounded-lg ${product.quantity === 0 ? 'opacity-50' : ''}`}
        />
        {product.quantity === 0 && (
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-lg">
            <span className="text-white text-lg font-semibold">Out of Stock</span>
          </div>
        )}
      </div>
      <div className="mt-4">
        <h3 className="text-lg font-semibold">{product.name}</h3>
        <p className="text-[#007D44]">{product.brand}</p>
        <p className="text-[#007D44] font-bold mt-2">${product.price}</p>
      </div>
      {inCart ? (
        <div className="mt-4 flex items-center justify-between border bg-slate-100 shadow-md rounded-full">
          <button
            onClick={() => {
              if (quantity > 1) {
                setQuantity((prevQuantity) => prevQuantity - 1);
                updateCartCount();
              }
            }}
            className="bg-[#38c13a] text-white py-2 px-4 rounded-lg hover:bg-[#2e9830]"
          >
            -
          </button>
          <span className="text-lg font-semibold">{quantity}</span>
          <button
            onClick={() => {
              setQuantity((prevQuantity) => prevQuantity + 1);
              updateCartCount();
            }}
            className="bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44]"
          >
            +
          </button>
        </div>
      ) : (
        <button
          onClick={handleAddToCart}
          className={`mt-4 bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44] ${
            product.quantity === 0 ? 'cursor-not-allowed opacity-50' : ''
          }`}
          disabled={product.quantity === 0}
        >
          Add to cart
        </button>
      )}
    </div>
  );
};


const SpongeProducts = () => {
  const [cartCount, setCartCount] = useState(0);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);


  const [uploadStatus, setUploadStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [cloudinaryUrls, setCloudinaryUrls] = useState({});
  const [products, setProducts] = useState([]);
  const [hasIncompatibleItems, setHasIncompatibleItems] = useState(false); // New state
    

 // Auto-upload products when component mounts
 useEffect(() => {
  const uploadProducts = async () => {
    try {
      setIsUploading(true);

      // Prepare products for upload
      const productsToUpload = spongeproducts.map(product => ({
        ...product,
        id: product.id,
        name: product.name,
        brand: product.brand,
        description: product.description,
        category: 'spongeproducts',
        quantity: 0,
        price: parseFloat(product.price.replace('$', ''))
      }));

      try {
        const result = await productService.bulkCreateProducts(productsToUpload);
        
        setUploadStatus({
          success: true,
          message: `${result.created} sponge products uploaded successfully`
        });
      } catch (error) {
        setUploadStatus({
          success: false,
          message: error.response?.data?.message || 'Product upload failed'
        });
      }
    } catch (error) {
      console.error('Error uploading products:', error);
      setUploadStatus({
        success: false,
        message: 'Failed to upload products'
      });
    } finally {
      setIsUploading(false);
    }
  };


  // Fetch products by category
  const fetchProducts = async () => {
    try {
      const result = await productService.getProductsByCategory('spongeproducts');
      
      // If no products exist, trigger upload
      if (result.count === 0) {
        await uploadProducts();
      } else {
        setProducts(result.products);
        console.log(result.products)
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  fetchProducts();
}, []);

 

  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items on initial load
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);

  }, []);

  const updateCartCount = () => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items whenever cart updates
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);
  };

  const forceUpdateProducts = () => {
    setForceUpdateKey(prevKey => prevKey + 1); // This will force a re-render in ProductCard
  };

  return (
    <>
      <Navbar cartCount={cartCount} updateCartCount={updateCartCount} forceUpdateProducts={forceUpdateProducts} /> {/* Pass cart count to Navbar */}

      {/* Upload Status Notification */}
      {isUploading && (
        <div className="fixed top-0 left-0 w-full bg-yellow-500 text-white text-center py-2 z-50">
          Uploading sponge products...
        </div>
      )}
      
      {uploadStatus && (
        <div 
          className={`
            fixed 
            top-0 
            left-0 
            w-full 
            text-center 
            py-2 
            z-50 
            ${uploadStatus.success ? 'bg-green-500' : 'bg-red-500'} 
            text-white
          `}
        >
          {uploadStatus.message}
        </div>
      )}

      <div className="min-h-screen p-8 max-sm:p-1 lg:mt-[70px] mt-[130px]">

              {/* Add incompatible items warning */}
      {hasIncompatibleItems && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">
            Your cart contains items from a different box type. Please complete your current order 
            or clear the cart before selecting individual sponge products.
          </span>
          <button
            onClick={() => setHasIncompatibleItems(false)}
            className="absolute top-0 right-0 px-2 py-1"
          >
            ×
          </button>
        </div>
      )}
        <div className="flex justify-between items-center max-sm:flex-col max-sm:items-start mb-6">

    
          <h3 className="text-2xl font-semibold">Sponge Products</h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6">
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              updateCartCount={updateCartCount}
              forceUpdateKey={forceUpdateKey} // Pass updateCartCount to ProductCard
            />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SpongeProducts;